import React from "react";
import { Button, Input } from "reactstrap";
import ReactTable from "react-table";
import { Card, CardBody } from "reactstrap";
import {
  displayDefaultDateFormater,
  mustBeArray,
  volumeFormater,
} from "../../utils/lib";
import UrgentRequestDisclaimer from "../Common/UrgentRequestDisclaimer";
import {BASE_URL, IsNullOrUndefined, SHORT_DATE_FORMAT} from "../../constants";
import moment from "moment/moment";

const UrgentCollections = ({
  handleSelection,
  list,
  selectedCollection,
  handleTermsAgreementChange,
  conditionAgreed,
  autoApproveUrgentRunEstimate,
  expectedVolumeMet,
  loading, 
  driverRuns,
}) => {
  const getButtonClassName = (id) => {
    if (selectedCollection && selectedCollection !== id) return "bg-faded";
    return "bg-danger";
  };

  const getCollectionColumns = () => {
    return [
      {
        id: "location",
        Header: "Location",
        accessor: (x) => x.locationName,
      },
      {
        id: "runDate",
        Header: "Expected Run Date",
        accessor: (x) => x.runDate,
        maxWidth: 200,
        Cell: (row) => (
          <div className="flex justify-content-center ">
            { row.original.existingRunId > 0 &&
                (<a href={`${BASE_URL}/runs/${getRunUrl(row.original.existingRunId)}`}
                    target={'_blank'}>{moment(row.original.existingTimeStart).format(SHORT_DATE_FORMAT)} -
                  #{row.original.existingRunId}</a>)
            }            
          </div>
        ),
      },
      {
        id: "estimate",
        Header: "Estimate",
        accessor: (x) => x.estimatedToReach,
        maxWidth: 130,
        Cell: (row) => (
          <div className="flex justify-content-center ">
            {`${
              !row.original.isTinLocation ? `${row.original.estimated}%` : ""
            }`}
          </div>
        ),
      },
      {
        id: "expected",
        Header: "Expected",
        accessor: (x) => x.expectedVolume,
        maxWidth: 130,
        align: "center",
        Cell: (row) => (
          <div className="flex justify-content-center ">
            {`${
              !row.original.isTinLocation
                ? `${volumeFormater(row.original.estimatedToReach)}`
                : `${row.original.tinsExpected} tins`
            }`}
          </div>
        ),
      },
      {
        id: "requestUrgent",
        accessor: (x) => x.selected,
        Header: "Request Urgent",
        maxWidth: 160,
        sortable: false,
        Cell: (row) => (
          <div className="flex justify-content-center">            
            <Button
                className={`btn ${getButtonClassName(row.original.locationId)}`}
                onClick={() => handleSelection(row.original.locationId)}
            >
              Request Urgent
            </Button>
          </div>
        ),
      },
    ];
  };
  const getLocationName = () => {
    const location = mustBeArray(list).find(
      (o) => o.locationId === selectedCollection
    );
    return location && location.locationName;
  };

  const getRunUrl = (runId) =>{
    // if the runId is in the drivers runs, then use the drivers url, otherwise use the search url
    const driverRun = driverRuns.items.find(x => x.id === parseInt(runId));

    let preFix = IsNullOrUndefined(driverRun) ? "search" : "driver";

    return `${preFix}/${runId}`;
  }
  
  
  return (
    <React.Fragment>
      <Card className="p-1">
        <CardBody>
          <ReactTable
            sortable
            filterable={false}
            showPagination={true}
            defaultPageSize={20}
            data={mustBeArray(list)}
            columns={getCollectionColumns()}
            minRows={
              mustBeArray(list).length === 0
                ? 5
                : mustBeArray(list).length > 20
                ? 20
                : mustBeArray(list).length
            }
            className="selectableRowTable br-1"
            loading={loading}
          />
        </CardBody>
      </Card>
      {selectedCollection && (
        <Card className="p-1">
          <h5>{`${getLocationName()} - Urgent Collection disclaimer`}</h5>
          <CardBody>
            <React.Fragment>
              <UrgentRequestDisclaimer 
                volume={`${autoApproveUrgentRunEstimate}%`}
                expectedVolumeMet={expectedVolumeMet}
              />
              <div className={"ml-2 mt-h flex align-center"}>
                <Input
                  type="checkbox"
                  className="mr-q mb-q"
                  onChange={(e) => handleTermsAgreementChange(e)}
                  checked={conditionAgreed}
                />{" "}
                Yes I accept
              </div> 
            </React.Fragment>
          </CardBody>
        </Card>
      )}
    </React.Fragment>
  );
};
export default UrgentCollections;
